import { Dispatch, SetStateAction } from "react"

import { HexColorInput, HexColorPicker } from "react-colorful"
import { css, cx } from "@emotion/css"

import { ClickAwayListener } from "@material-ui/core"

type Props = {
  name: string
  handlePicker: (arg: boolean) => void
  open: boolean
  color: string
  setColor: Dispatch<SetStateAction<string>>
  handleBlur: (itm: string) => void
  disabled?: boolean
}

export const ColorPickerField = (props: Props) => {
  const { open, color, setColor, handleBlur, handlePicker, disabled } = props

  const cssStyles = css`
    background-color: ${color};
    width: var(--spacing-s);
    height: var(--spacing-s);
    margin-left: var(--spacing-xs);
    border-radius: 50%;
  `

  const handleClickAway = () => {
    open && handleBlur(color)
    handlePicker(false)
  }
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div style={{ position: "relative" }}>
        <div
          className={cx(styles.textfieldWrapper, {
            [styles.openTextfieldWrapper]: open,
          })}
        >
          <div
            onClick={() => !disabled && handlePicker(true)}
            className={cx(styles.textfield, { [styles.disabled]: disabled })}
          >
            {color}
          </div>
          <div
            className={cssStyles}
            onClick={() => !disabled && handlePicker(true)}
          />
        </div>
        {open && (
          <div className={styles.clrpickerCntr}>
            <HexColorPicker color={color} onChange={setColor} />
            <HexColorInput
              className={styles.clrinput}
              color={color}
              onChange={setColor}
            />
          </div>
        )}
      </div>
    </ClickAwayListener>
  )
}

const styles = {
  textfield: css`
    min-width: 107px;
    max-height: var(--spacing-xxl-2);
    border-radius: 4px;
    border: 1px solid var(--light-grey);
    padding-left: var(--spacing-xs);
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    padding: 12px;
  `,
  openTextfieldWrapper: css`
    display: flex;
    align-items: center;
    flex-direction: row;
  `,
  textfieldWrapper: css`
    display: flex;
    align-items: center;
    flex-direction: row;
  `,
  clrpickerCntr: css`
    position: absolute;
    top: 0%;
    left: 100%;
    z-index: 999;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  clrinput: css`
    width: 100px;
    height: var(--spacing-xxl-2);
    margin-top: var(--spacing-xs);
    border-radius: 4px;
    border: 1px solid var(--light-grey);
    padding-left: var(--spacing-xs);
    font-size: 0.875rem;
    display: flex;
  `,
  disabled: css`
    color: rgba(0, 0, 0, 0.38);
    border-color: var(--disabled-grey);
    cursor: default;
  `,
}
